import { render, staticRenderFns } from "./StatsInstances.vue?vue&type=template&id=6e6ffead&"
import script from "./StatsInstances.vue?vue&type=script&lang=js&"
export * from "./StatsInstances.vue?vue&type=script&lang=js&"
import style0 from "./StatsInstances.vue?vue&type=style&index=0&id=6e6ffead&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports